import PropTypes from 'prop-types';
import { Fragment } from 'react';

import { ButtonSubtle } from '../../Buttons';
import useStepperApi from '../hooks/useStepperApi';

import LineBar from './LineBar';
import Milestone from './Milestone';

import '../styles.css';

const GATE_LABEL_STYLES =
  'absolute left-1/2 -translate-x-1/2 transform w-24 text-center';

const Gate = ({
  ariaPosinset,
  ariaSetsize,
  currentStep,
  disableNav,
  gate,
  isActive,
  steps,
}) => {
  const { goToGate } = useStepperApi();
  const hasError =
    isActive && [...steps.values()].some((step) => !!step.isError);
  const disableNavButton = disableNav || !gate.isComplete;

  return (
    <li
      aria-current={isActive ? 'step' : undefined}
      aria-label={gate.label}
      aria-posinset={ariaPosinset}
      aria-setsize={ariaSetsize}
      className="flex flex-auto relative m-0 last:flex-initial"
    >
      <LineBar
        currentStep={currentStep}
        isActive={isActive}
        isComplete={gate.isComplete}
        steps={steps}
      />
      <div className="stepper-milestone absolute -left-4">
        {disableNavButton ? (
          <Fragment>
            <Milestone
              disableNavButton
              isActive={isActive}
              isComplete={gate.isComplete}
              isError={hasError}
            />
            <p className={GATE_LABEL_STYLES}>{gate.label}</p>
          </Fragment>
        ) : (
          <ButtonSubtle
            className="border-none p-0 font-normal text-current hover:text-current"
            onClick={() => goToGate(gate.id)}
          >
            <Milestone
              isActive={isActive}
              isComplete={gate.isComplete}
              isError={hasError}
            />
            <p className={GATE_LABEL_STYLES}>{gate.label}</p>
          </ButtonSubtle>
        )}
      </div>
    </li>
  );
};

Gate.propTypes = {
  ariaPosinset: PropTypes.number.isRequired,
  ariaSetsize: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  disableNav: PropTypes.bool.isRequired,
  gate: PropTypes.shape({
    id: PropTypes.string.isRequired,
    isComplete: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  isActive: PropTypes.bool.isRequired,
  steps: PropTypes.instanceOf(Map).isRequired,
};

export default Gate;
